"use strict";

var _utils = require("../../../utils");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

function getItemUploadedSize(_ref) {
  var loaded = _ref.loaded,
      assetId = _ref.assetId;
  if (loaded) return loaded;
  var localAsset = (0, _utils.getAssetFromLocalStorage)(assetId);
  return localAsset ? localAsset.uploadedBytes : 0;
}

var _default = getItemUploadedSize;
exports["default"] = _default;